/*
  TODO: Lighthouse scores are dropping due to authentication
  features. Disabling these features for now
*/
import {
  Auth,
  getAuth,
  GoogleAuthProvider,
} from 'firebase/auth';
import { firebaseAppClient } from '../firebase.services';

// auth = <Auth>{};
// const auth: Auth;
const auth: Auth = getAuth(firebaseAppClient);
const googleProvider = new GoogleAuthProvider();
export { auth, googleProvider };
